import { myCallsheetApi } from '../../../api/callsheet/callsheet.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { myCallsheetService } from '../CallsheetService/CallsheetService.connected';
import { myProductionService } from '../ProductionService/ProductionService.connected';
import { myBookingService } from '../BookingService/BookingService.connected';
import { createCallsheetMutationService } from './CallsheetMutationService.impl';

export const myCallsheetMutationService = createCallsheetMutationService({
  api: myCallsheetApi,
  services: {
    errorService: myErrorService,
    messageService: myMessageService,
    callsheetService: myCallsheetService,
    productionService: myProductionService,
    bookingService: myBookingService
  }
});
